import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import utility, { moneyFormat } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import { IoIosArrowBack, IoIosStar, IoIosStarOutline } from "react-icons/io"
import { AbsoluteContainer, AppLink, AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, PageTitle, PageWrapper } from "src/style"
import ProductImage from 'src/assets/img/product-image.svg'
import QoreidIcon from 'src/assets/img/qoreid-icon.svg'
import { Product } from "src/model"
import { ProductInfoTab, ProductView } from "src/component"
import { InstallationConfirmation, IntegrationRequest, ProductSharing } from "src/popup"
import { VscGlobe } from "react-icons/vsc";
import { ReactComponent as MoneyIcon } from "src/assets/img/money-icon.svg";
import { BsShare } from "react-icons/bs"
import { IoArrowBackOutline } from "react-icons/io5";
//import { products } from "src/utils/mock-data"

const ProductDetails = () => {
    const navigate = useNavigate()
    const { productId } = useParams()
    const { API } = useContext(ApiContext)
    const {info: {selectedProduct}, setInfoProperty} = useContext(AppInfoContext)
    const {decisionBox} = useContext(VisibilityContext)
    const [productImage, setProductImage] = useState(ProductImage)
    const [product, setProduct] = useState<Product|null>(selectedProduct)
    const [products, setProducts] = useState<Array<Product>>([])
    const [productWebsite, setProductWebsite] = useState('')
    const [view, setView] = useState('')
    
    useEffect(() => {
        if (selectedProduct?.id) {
            setProduct(selectedProduct)
            setProductImage(selectedProduct?.screenshotUrls?.[0])
            setProductWebsite(selectedProduct?.serviceProvider?.websiteURL || selectedProduct?.websiteUrl)

            handleFetchProducts(selectedProduct?.serviceCategoryId)
        }
    }, [selectedProduct])

    useEffect(() => {
        getProductById()
    }, [])

    function getProductById () {
        API.getProductById(productId)
    }

    async function handleFetchProducts (serviceCategoryId: string) {
        const response = await API.getProductsWithoutPagination({serviceCategoryId})
        if (response) {
            const items = []
            for (let item of response) {
                if (item.id != selectedProduct.id) items.push(item)
            }
            setProducts(items)
        }
    }

    async function handleProduct (product: Product) {
        await setInfoProperty('selectedProduct', product)
        navigate(`/client/discover/product/${product.id}`)
    }

    function handleProductIntegration () {
        setView(product?.integrationStatus || 'ComingSoon')

        if (product?.integrationStatus === 'AvailableAutomatically') {
            decisionBox.show(
                `Are you sure you are ready to install ${product?.name} for your Bank? Click yes to proceed`,
                () => setView('product-installation'),
                decisionBox.hide,
                `Yes`,
                'No'
            )
        }
    }

    return (
        <>
            <PageWrapper>
                <FlexRow 
                    gap="0.7" bottomMargin="2"
                    onClick={() => navigate(-1)}
                >
                    <IoArrowBackOutline color="#0A756F" fontSize='1.7rem' />
                    <AppText 
                        color="#0A756F" fontWeight="500"
                        cursor="pointer"
                    >
                        Back
                    </AppText>
                </FlexRow>
                <FlexRow justifyContent="space-between" alignItems="flex-start" gap="2.5" wrap='wrap'>
                    {/* <FlexRow 
                        width="auto" sizeUnit="" gap="1.5"
                        onClick={() => navigate(-1)}
                    >
                        <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                            <IoIosArrowBack />
                        </AppSpan>
                        <FlexRow gap="1" width="auto" sizeUnit="" wrap="wrap">
                            <PageTitle 
                                color='#101828' textSize='3' fontWeight="500"
                            >
                                {product?.name}
                            </PageTitle>
                            <AppLink
                                color="#3374EF" textSize="1.6"
                                fontWeight="500" hoverColor="#ADB5BD"
                                href='qoreid.com' target='_blank'
                            >
                                {product?.serviceProvider?.websiteURL || product?.websiteUrl}
                            </AppLink>
                        </FlexRow>
                    </FlexRow> */}
                    <FlexRow 
                        width="auto" sizeUnit="" gap="1.5"
                        alignItems="flex-start"
                    >
                        <Circle 
                            size="7" bgColor='#ffffff' 
                            borderColor='#EAECF0'
                            className='fixed-flex-shape'
                            style={{overflow: 'hidden'}}
                        >
                            <Circle 
                                size='6'
                                style={{overflow: 'hidden'}}
                            >
                                <img 
                                    src={product?.logoUrl} 
                                    className='img-covered' 
                                    style={{objectFit: 'contain'}} 
                                />
                            </Circle>
                        </Circle>
                        <CustomContainer width="auto" sizeUnit="">
                            <PageTitle 
                                color='#101828' textSize='3' fontWeight="500"
                            >
                                {product?.name}
                            </PageTitle>
                            <FlexRow gap="2.5" width="auto" sizeUnit="" wrap="wrap">
                                <FlexRow width="auto" sizeUnit="" gap="0.7">
                                    <VscGlobe color='#3374EF' fontSize='2rem' />
                                    <AppLink
                                        color="#3374EF" textSize="1.6"
                                        fontWeight="500" hoverColor="#ADB5BD"
                                        href={productWebsite} target='_blank'
                                    >
                                        {productWebsite}
                                    </AppLink>
                                </FlexRow>

                                <FlexRow 
                                    gap='1.2'
                                    width="auto" sizeUnit=""
                                >
                                    <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                        {
                                            Array.from(Array(5).keys()).map((item) => {
                                                return (
                                                    <CustomContainer 
                                                        width='auto' sizeUnit=''
                                                        key={item}
                                                    >
                                                        { product?.productStatistic?.averageRating! >= (item + 1) ?
                                                            <IoIosStar fill='#409089' fontSize='1.5rem' />
                                                            : <IoIosStarOutline fill='#344054' fontSize='1.5rem' />
                                                        }
                                                    </CustomContainer>
                                                )
                                            })
                                        }
                                    </FlexRow>
                                    <AppSpan textSize='1'>{(product?.productStatistic?.averageRating || 0)?.toFixed(1)}</AppSpan>
                                </FlexRow>

                                <FlexRow width="auto" sizeUnit="" gap="0.5">
                                    <MoneyIcon className="icon-component" />
                                    { product?.setupFee ?
                                        <AppText textSize='1.6' fontWeight="500" color='#409089'>₦{moneyFormat(product?.setupFee || 0)}</AppText>
                                        : <AppText textSize='1.6' fontWeight="500" color='#0A756F'>No upfront cost</AppText>
                                    }
                                </FlexRow>

                                <FlexRow 
                                    width="auto" sizeUnit="" gap="1"
                                    onClick={() => setView('product-sharing')}
                                >
                                    <BsShare fill="#0085F2" fontSize='1.4rem' />
                                    <AppSpan 
                                        color="#0085F2" textSize='1.6' 
                                        fontWeight="500" cursor="pointer"
                                    >
                                        Share
                                    </AppSpan>
                                </FlexRow>
                            </FlexRow>
                        </CustomContainer>
                    </FlexRow>
                    { !product?.installed &&
                        <Button
                            width={product?.integrationStatus === 'AvailableAutomatically' ? '7.3' :product?.integrationStatus === 'AvailableManually' ? '13' : '18' }
                            height='4' radius='0.8' 
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' 
                            borderColor='#0D968F'
                            onClick={handleProductIntegration}
                        >
                            {product?.integrationStatus === 'AvailableAutomatically' ? 'Install' : product?.integrationStatus === 'AvailableManually' ? 'Request Demo': 'Request Early Access'}
                        </Button>
                    }
                </FlexRow>

                <CustomContainer topMargin='2.5'>
                    <CustomContainer 
                        width="100" sizeUnit="%"
                        height="31" //height="27"
                        //maxWidth='96.8' //mxWUnit='%'
                        radius='1.1' topMargin='1.5'
                        //className='product-image-container'
                    >
                        <img 
                            src={productImage} 
                            className='img-covered' 
                            //style={{objectFit: 'contain'}}  
                        />
                    </CustomContainer>
                    <CustomContainer
                        className='scrollable-container'
                    >
                        <FlexRow 
                            justifyContent='center' 
                            gap='4' topMargin='4'
                            style={{minWidth: 'fit-content'}}
                        >
                            { product?.screenshotUrls?.length! > 1 &&
                                product?.screenshotUrls?.map((img, index) => {
                                    return (
                                        <CustomContainer 
                                            width="21" height="10.1" 
                                            radius='0.8' borderColor='#E9EAEC'
                                            key={index}
                                            onClick={() => setProductImage(img)}
                                        >
                                            <img src={img} className='img-covered' />
                                        </CustomContainer>
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer topMargin='2.5'>
                    <ProductInfoTab 
                        product={product}
                    />
                </CustomContainer>
                
                <CustomContainer topMargin="1.5">
                    <AppText textSize="1.9" fontWeight="500" color="#101828">Related Product</AppText>
                    <CustomContainer 
                        topMargin="1.5"
                        className='scrollable-container'
                    >
                        <FlexRow 
                            gap="2" alignItems='stretch'
                            style={{minWidth: 'fit-content'}}
                        >
                            {
                                products?.map((product, index) => {
                                    return (
                                        <ProductView
                                            key={index}
                                            product={product}
                                            isComingSoon={product?.integrationStatus === 'ComingSoon'}
                                            onClick={() => handleProduct(product)} 
                                        />
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
            </PageWrapper>
            { ['AvailableManually', 'ComingSoon'].includes(view) &&
                <IntegrationRequest
                    isDemoRequest={view === 'AvailableManually'}
                    product={product}
                    close={() => setView('')}
                />
            }
            { view === 'product-installation' &&
                <InstallationConfirmation
                    product={product} 
                    getProductUpdate={getProductById}
                    close={() => setView('')}
                />
            }
            { view === 'product-sharing' &&
                <ProductSharing 
                    productId={productId}
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('discover/product/:productId', 'Product Details', <ProductDetails/>)